/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementBase,
  AgreementBaseOptional,
  AgreementBaseMetaI,
  AgreementBaseTrackedI,
} from "./agreement-base";
import { AgreementBaseTracked, AgreementBaseMeta } from "./agreement-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementCategoryFull,
  AgreementCategoryFullOptional,
  AgreementCategoryFullMetaI,
  AgreementCategoryFullTrackedI,
} from "./agreement-category-full";
import {
  AgreementCategoryFullTracked,
  AgreementCategoryFullMeta,
} from "./agreement-category-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementInstanceFull,
  AgreementInstanceFullOptional,
  AgreementInstanceFullMetaI,
  AgreementInstanceFullTrackedI,
} from "./agreement-instance-full";
import {
  AgreementInstanceFullTracked,
  AgreementInstanceFullMeta,
} from "./agreement-instance-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementRef,
  AgreementRefOptional,
  AgreementRefMetaI,
  AgreementRefTrackedI,
} from "./agreement-ref";
import { AgreementRefTracked, AgreementRefMeta } from "./agreement-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";

/**
 *
 * @export
 * @interface AgreementFull
 */
export interface AgreementFullOptional extends AgreementBaseOptional {
  /**
   *
   * @type {number}
   * @memberof AgreementFull
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof AgreementFull
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementFull
   */
  agreementName?: string;
  /**
   *
   * @type {boolean}
   * @memberof AgreementFull
   */
  isGlobal?: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementFull
   */
  sortOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof AgreementFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementFull
   */
  isNew?: boolean;
  /**
   *
   * @type {Array<AgreementInstanceFull>}
   * @memberof AgreementFull
   */
  agreementInstances?: AgreementInstanceFullOptional[];
  /**
   *
   * @type {Array<AgreementCategoryFull>}
   * @memberof AgreementFull
   */
  agreementCategories?: AgreementCategoryFullOptional[];
}

export interface AgreementFull
  extends AgreementFullOptional, AgreementBase, AgreementRef, Deletable {
  /**
   *
   * @type {number}
   * @memberof AgreementFull
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof AgreementFull
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementFull
   */
  agreementName?: string;
  /**
   *
   * @type {boolean}
   * @memberof AgreementFull
   */
  isGlobal?: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementFull
   */
  sortOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof AgreementFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementFull
   */
  isNew?: boolean;
  /**
   *
   * @type {Array<AgreementInstanceFull>}
   * @memberof AgreementFull
   */
  agreementInstances?: AgreementInstanceFull[];
  /**
   *
   * @type {Array<AgreementCategoryFull>}
   * @memberof AgreementFull
   */
  agreementCategories?: AgreementCategoryFull[];
}

export interface AgreementFullTrackedI extends AgreementBaseOptional {
  /**
   *
   * @type {number}
   * @memberof AgreementFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementFull
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementFull
   */
  agreementName?: string;
  agreementNameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementFull
   */
  isGlobal?: boolean;
  isGlobalIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementFull
   */
  sortOrder?: number;
  sortOrderIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {Array<AgreementInstanceFull>}
   * @memberof AgreementFull
   */
  agreementInstances?: AgreementInstanceFullTrackedI[];
  agreementInstancesIsSet: boolean;
  /**
   *
   * @type {Array<AgreementCategoryFull>}
   * @memberof AgreementFull
   */
  agreementCategories?: AgreementCategoryFullTrackedI[];
  agreementCategoriesIsSet: boolean;
}

transformDatesMap.set("AgreementFull", function (model: AgreementFull) {
  const transformDatesagreementInstances = transformDatesMap.get(
    "AgreementInstanceFull",
  );
  if (transformDatesagreementInstances) {
    model.agreementInstances?.forEach((sub) => {
      transformDatesagreementInstances(sub);
    });
  }
  const transformDatesagreementCategories = transformDatesMap.get(
    "AgreementCategoryFull",
  );
  if (transformDatesagreementCategories) {
    model.agreementCategories?.forEach((sub) => {
      transformDatesagreementCategories(sub);
    });
  }
});

export type AgreementFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  agreementName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isGlobal: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  sortOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  agreementInstances: PropertyMeta<AgreementInstanceFullMetaI>;
  //isDate: false
  //isDatetime: false
  agreementCategories: PropertyMeta<AgreementCategoryFullMetaI>;
}>;

export var AgreementFullMeta: AgreementFullMetaI = {} as AgreementFullMetaI;
AgreementFullMeta = typeMeta("AgreementFull", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
  agreementName: propertyMeta(
    "agreementName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isGlobal: propertyMeta(
    "isGlobal",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  sortOrder: propertyMeta(
    "sortOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  agreementInstances: propertyMeta(
    "agreementInstances",
    true,
    false,
    false,
    AgreementInstanceFullMeta,
  ),
  agreementCategories: propertyMeta(
    "agreementCategories",
    true,
    false,
    false,
    AgreementCategoryFullMeta,
  ),
});

const metaI = AgreementFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([AgreementRefMeta]);
  metaI.assignId.inheritedFrom = AgreementRefMeta.assignId;
  metaI.tempID.inheritedFrom = AgreementRefMeta.tempID;
  metaI.interfaces = metaI.interfaces.concat([AgreementBaseMeta]);
  metaI.agreementName.inheritedFrom = AgreementBaseMeta.agreementName;
  metaI.isGlobal.inheritedFrom = AgreementBaseMeta.isGlobal;
  metaI.sortOrder.inheritedFrom = AgreementBaseMeta.sortOrder;
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
});

export class AgreementFullTracked
  extends AgreementBaseTracked
  implements AgreementFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  agreementName__I?: string = undefined;
  agreementNameIsSet: boolean = false;
  set agreementName(v: undefined | string) {
    if (v !== undefined) {
      this.agreementName__I = v;
      this.agreementNameIsSet = true;
    } else {
      this.agreementName__I = v || undefined;
      this.agreementNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementName() {
    return this.agreementName__I;
  }
  isGlobal__I?: boolean = undefined;
  isGlobalIsSet: boolean = false;
  set isGlobal(v: undefined | boolean) {
    if (v !== undefined) {
      this.isGlobal__I = v;
      this.isGlobalIsSet = true;
    } else {
      this.isGlobal__I = v || undefined;
      this.isGlobalIsSet = false;
    }
    this.changeTracker = true;
  }
  get isGlobal() {
    return this.isGlobal__I;
  }
  sortOrder__I?: number = undefined;
  sortOrderIsSet: boolean = false;
  set sortOrder(v: undefined | number) {
    if (v !== undefined) {
      this.sortOrder__I = v;
      this.sortOrderIsSet = true;
    } else {
      this.sortOrder__I = v || undefined;
      this.sortOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get sortOrder() {
    return this.sortOrder__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  agreementInstances__I?: AgreementInstanceFullTracked[] = undefined;
  agreementInstancesIsSet: boolean = false;
  set agreementInstances(v: undefined | AgreementInstanceFullTracked[]) {
    if (v !== undefined) {
      this.agreementInstances__I = v;
      this.agreementInstancesIsSet = true;
    } else {
      this.agreementInstances__I = v || undefined;
      this.agreementInstancesIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementInstances() {
    return this.agreementInstances__I;
  }
  agreementCategories__I?: AgreementCategoryFullTracked[] = undefined;
  agreementCategoriesIsSet: boolean = false;
  set agreementCategories(v: undefined | AgreementCategoryFullTracked[]) {
    if (v !== undefined) {
      this.agreementCategories__I = v;
      this.agreementCategoriesIsSet = true;
    } else {
      this.agreementCategories__I = v || undefined;
      this.agreementCategoriesIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementCategories() {
    return this.agreementCategories__I;
  }
  constructor(config?: AgreementFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.agreementInstances?.forEach((a) => a.setIds());

    this.agreementCategories?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: AgreementFullOptional,
    options?: AssignOptions,
  ): AgreementFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (
      config.agreementName &&
      this.agreementNameApplyFilter(optionsRequired.filter)
    ) {
      this.agreementName = config.agreementName;
      if (optionsRequired.unassign) this.agreementNameIsSet = false;
      else this.agreementNameIsSet = true;
    }
    if (config.isGlobal && this.isGlobalApplyFilter(optionsRequired.filter)) {
      this.isGlobal = config.isGlobal;
      if (optionsRequired.unassign) this.isGlobalIsSet = false;
      else this.isGlobalIsSet = true;
    }
    if (config.sortOrder && this.sortOrderApplyFilter(optionsRequired.filter)) {
      this.sortOrder = config.sortOrder;
      if (optionsRequired.unassign) this.sortOrderIsSet = false;
      else this.sortOrderIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (
      config.agreementInstances &&
      this.agreementInstancesApplyFilter(optionsRequired.filter)
    ) {
      this.agreementInstances = config.agreementInstances?.map(
        (a) => new AgreementInstanceFullTracked(a, options),
      );
      if (optionsRequired.unassign) this.agreementInstancesIsSet = false;
      else this.agreementInstancesIsSet = true;
    }
    if (
      config.agreementCategories &&
      this.agreementCategoriesApplyFilter(optionsRequired.filter)
    ) {
      this.agreementCategories = config.agreementCategories?.map(
        (a) => new AgreementCategoryFullTracked(a, options),
      );
      if (optionsRequired.unassign) this.agreementCategoriesIsSet = false;
      else this.agreementCategoriesIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): AgreementFullTrackedI {
    const cloned = {} as AgreementFullTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.agreementNameIsSetDeep() &&
      this.agreementNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementNameIsSet = true;
      cloned.agreementName = this.agreementName;
    } else {
      //cloned.agreementNameIsSet = false
    }
    if (
      this.isGlobalIsSetDeep() &&
      this.isGlobalApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isGlobalIsSet = true;
      cloned.isGlobal = this.isGlobal;
    } else {
      //cloned.isGlobalIsSet = false
    }
    if (
      this.sortOrderIsSetDeep() &&
      this.sortOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sortOrderIsSet = true;
      cloned.sortOrder = this.sortOrder;
    } else {
      //cloned.sortOrderIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.agreementInstancesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.agreementInstancesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementInstancesIsSet = true;
      cloned.agreementInstances = this.agreementInstances
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.agreementInstancesIsSet = false
    }
    if (
      this.agreementCategoriesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.agreementCategoriesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementCategoriesIsSet = true;
      cloned.agreementCategories = this.agreementCategories
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.agreementCategoriesIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): AgreementFullTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.agreementNameApplyFilter(filter)) this.agreementNameIsSet = false;

    if (!this.isGlobalApplyFilter(filter)) this.isGlobalIsSet = false;

    if (!this.sortOrderApplyFilter(filter)) this.sortOrderIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.agreementInstancesApplyFilter(filter))
      this.agreementInstancesIsSet = false;

    this.agreementInstances?.forEach((a) => a.unassignAll(filter));
    if (!this.agreementCategoriesApplyFilter(filter))
      this.agreementCategoriesIsSet = false;

    this.agreementCategories?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementFullMeta.assignId,
      AgreementFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementFullMeta.tempID,
      AgreementFullMeta,
      this.tempID,
      this,
    );
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  agreementNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementFullMeta.agreementName,
      AgreementFullMeta,
      this.agreementName,
      this,
    );
  }
  agreementNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementNameIsSet && this.agreementNameApplyFilter(filter))
      return true;

    return false;
  }
  isGlobalApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementFullMeta.isGlobal,
      AgreementFullMeta,
      this.isGlobal,
      this,
    );
  }
  isGlobalIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isGlobalIsSet && this.isGlobalApplyFilter(filter)) return true;

    return false;
  }
  sortOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementFullMeta.sortOrder,
      AgreementFullMeta,
      this.sortOrder,
      this,
    );
  }
  sortOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sortOrderIsSet && this.sortOrderApplyFilter(filter)) return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementFullMeta.isDeleted,
      AgreementFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(AgreementFullMeta.isNew, AgreementFullMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  agreementInstancesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementFullMeta.agreementInstances,
      AgreementFullMeta,
      this.agreementInstances,
      this,
    );
  }
  agreementInstancesIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.agreementInstancesIsSet &&
      this.agreementInstancesApplyFilter(filter)
    )
      return true;

    return this.agreementInstances?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  agreementCategoriesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementFullMeta.agreementCategories,
      AgreementFullMeta,
      this.agreementCategories,
      this,
    );
  }
  agreementCategoriesIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.agreementCategoriesIsSet &&
      this.agreementCategoriesApplyFilter(filter)
    )
      return true;

    return this.agreementCategories?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.agreementNameIsSetDeep(filter)) return true;
    if (this.isGlobalIsSetDeep(filter)) return true;
    if (this.sortOrderIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.agreementInstancesIsSetDeep(filter)) return true;
    if (this.agreementCategoriesIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
